module.exports = __webpack_public_path__ + "static/haus_4k-2fc2126d27dbf3ab13b83f6a37571d7b.webp";